<template>
    <div :id="tplSkinId" class="wrap">
        <MysohoSpecialHeader v-if="tplSkinId != 'tpl-basic'"/> 
        <MysohoHeader/> 
        <MysohoContent/>
        <MysohoFooter/>
    </div>
</template>

<script>
import '@/components/_load_componets_pc.js'
export default {
    name : 'MainPc'
    , data () {
        return {
            tplSkinId : `tpl-${this.getSkin()}`
        }
    }
    , computed : {
    }
    , mounted() {
    }
}
</script>
